import {
  ApiDeleteRequest,
  ApiGetRequest,
  ApiPostMultipart,
  ApiPostRequest,
  ApiPutRequest,
} from '../../api';
import { showNotif } from '../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title_nat: 'Container NAT',
    breadcrumb_nat: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'NAT Container',
        href: '/adm/opr/survey/nat-container',
        active: true,
      },
    ],
    title_out: 'Survey Container Out',
    breadcrumbs_out: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'Survey Out',
        href: '/adm/opr/survey/container-out',
        active: true,
      },
    ],
    title_quick: 'Container In',
    breadcrumb_quick: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'Survey In',
        href: '/adm/opr/survey/container-in',
        active: true,
      },
    ],
    title_form_survey: 'Form Container Survey In',
    breadcrumbs_survey: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'Survey',
        href: '/adm/opr/survey/container-in',
        active: true,
      },
    ],
    title_master: 'Master Part of Survey',
    breadcrumb_master: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'Master Part Of Survey',
        href: '/adm/opr/part-of-survey',
        active: true,
      },
    ],
    modal: false,
    items: [],
    items_pending: [],
    items_nat: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: '',
    filter_condition: '',
    filter_status: '',
    sortDesc: true,
    fields: [
      {
        key: 'survey_date_time',
        label: 'Date',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'consignee',
        label: 'Consignee',
        sortable: true,
      },
      {
        key: 'doc_no',
        label: 'B/L No',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
      },
      {
        key: 'size',
        label: 'Size',
      },
      {
        key: 'type',
        label: 'Type',
      },
      {
        key: 'condition',
        label: 'Condition',
        sortable: false,
      },
      {
        key: 'total_dmg',
        label: 'DMG',
        sortable: false,
      },
      {
        key: 'surveyor',
        label: 'Surveyor',
        sortable: false,
      },
      {
        key: 'eor_no',
        label: 'EOR No',
        sortable: false,
      },
      {
        key: 'eor_status',
        label: 'EOR Status',
      },
      {
        key: 'aksi',
      },
    ],
    fields_nat: [
      {
        key: 'code_survey',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'survey_date',
        label: 'Date',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
      },
      {
        key: 'size',
        label: 'Size',
      },
      {
        key: 'type',
        label: 'Type',
      },
      {
        key: 'aksi',
      },
    ],
    fields_out: [
      {
        key: 'survey_date_time',
        label: 'Date',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'shipper',
        label: 'Shipper',
        sortable: true,
      },
      {
        key: 'doc_no',
        label: 'Booking No',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
      },
      {
        key: 'size',
        label: 'Size',
      },
      {
        key: 'type',
        label: 'Type',
      },
      {
        key: 'condition',
        label: 'Condition',
        sortable: false,
      },
      {
        key: 'surveyor',
        label: 'Surveyor',
      },
      {
        key: 'aksi',
      },
    ],
    form: {
      container: '',
      size: '',
      type: '',
      condition: '',
      cleaning: '',
      place_interchange: 'EMPTY',
      is_for_eor: 0,
      mgw: '',
      tare: '',
      payload: '',
      nopol: '',
      sopir: '',
      date_manifest: '',
      grade: '',
      lokasi: '',
      pelabuhan: '',
      tgl_pelabuhan: '',
      photo_survey: [],
      damages: [],
    },
    form_damage: {
      loc: '',
      comp: '',
      dmg_width: '',
      dmg_height: '',
      dmg_unit: '',
      qty: '',
      account: '',
      dmg_type: '',
      action_repair: '',
      photo_damage: [],
    },
    container_list: [],
    detail: false,
    form_loc: {
      code: '',
      name: '',
    },
    data_loc: [],
    page_loc: 1,
    limit_loc: 10,
    total_loc: 0,
    search_loc: '',
    sortBy_loc: 'id_location',
    sortDesc_loc: false,
    fields_loc: [
      {
        key: 'code_loc',
        label: 'Kode',
        sortable: true,
        thStyle: {
          width: '100px',
        },
      },
      {
        key: 'location',
        label: 'Deskripsi',
        sortable: true,
      },
      {
        key: 'aksi',
        thStyle: {
          width: '100px',
        },
      },
    ],

    items_location: [],
    form_comp: {
      code: '',
      location: '',
      name: '',
    },
    data_comp: [],
    page_comp: 1,
    limit_comp: 10,
    total_comp: 0,
    search_comp: '',
    sortBy_comp: 'id_component',
    sortDesc_comp: false,
    fields_comp: [
      {
        key: 'comp_id',
        label: 'ID Component',
        sortable: true,
      },
      {
        key: 'code_comp',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'location',
        label: 'Location Repair',
        sortable: true,
      },
      {
        key: 'component',
        label: 'Component Repair',
        sortable: true,
      },
      {
        key: 'aksi',
      },
    ],

    items_component: [],
    select_component: false,
    form_dmg: {
      code: '',
      component: '',
      name: '',
    },
    data_dmg: [],
    page_dmg: 1,
    limit_dmg: 10,
    total_dmg: 0,
    search_dmg: '',
    sortBy_dmg: 'id_damage',
    sortDesc_dmg: false,
    fields_dmg: [
      {
        key: 'code_dmg',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'damage',
        label: 'Damage Repair',
        sortable: true,
      },
      {
        key: 'aksi',
      },
    ],

    data_ar: [],
    items_damage: [],
    form_ar: {
      code: '',
      damage: '',
      name: '',
    },
    page_ar: 1,
    limit_ar: 10,
    total_ar: 0,
    search_ar: '',
    sortBy_ar: 'id_repair',
    sortDesc_ar: false,
    fields_ar: [
      {
        key: 'code_repair',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'action_repair',
        label: 'Action Repair',
        sortable: true,
      },
      {
        key: 'aksi',
      },
    ],
    container_info: false,
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
  form_damage(state) {
    return state.data.form_damage;
  },
};

export const mutations = {
  changeSurvey(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchMasterLocation({ commit }, payload = {}) {
    let result = await ApiGetRequest(`opr/repair/location`, payload);
    if (!result.error) {
      commit('changeSurvey', {
        items_location: result.data.object,
      });
    }
  },

  async importDataLocation({ commit, dispatch, state }) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`opr/repair/location-import`, {
      items: data.import_form || [],
    });

    commit('changeSurvey', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async importDataComponent({ commit, dispatch, state }) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`opr/repair/component-import`, {
      items: data.import_form || [],
    });

    commit('changeSurvey', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async importDataDamage({ commit, dispatch, state }) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`opr/repair/damage-import`, {
      items: data.import_form || [],
    });

    commit('changeSurvey', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async importDataAction({ commit, dispatch, state }) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`opr/repair/action-import`, {
      items: data.import_form || [],
    });

    commit('changeSurvey', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async downloadMasterLocation({ commit }) {
    commit('changeSurvey', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/repair/location/download`);
    commit('changeSurvey', {
      loading: false,
    });

    if (result.error) {
      return false;
    } else {
      // The actual download
      var blob = new Blob([result.data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'repair_location.csv';

      document.body.appendChild(link);

      link.click();
      document.body.removeChild(link);

      return true;
    }
  },

  async getMasterLocation({ commit, state }, payload = null) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search_loc,
      page: data.page_loc,
      limit: data.limit_loc,
      sort: data.sortBy_loc,
      order: data.sortDesc_loc ? 'desc' : 'asc',
    };

    if (payload) {
      params = {
        ...params,
        ...payload,
      };
    }

    let result = await ApiGetRequest(`opr/repair/location`, params);
    if (!result.error) {
      commit('changeSurvey', {
        loading: false,
        data_loc: result.data.object || [],
        total_loc: result.data?.total || 0,
      });
    }
  },

  async createMasterLocation({ commit, state, dispatch }) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest('opr/repair/location', data.form_loc);
    commit('changeSurvey', {
      loading: false,
    });
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });

      return result.data.object || {};
    }

    return false;
  },

  async updateMasterLocation({ commit, state, dispatch }, payload = null) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(
      `opr/repair/location/${payload.id}`,
      data.form_loc
    );
    commit('changeSurvey', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });

      return result.data.object || {};
    }

    return false;
  },

  async deleteMasterLocation({ commit, dispatch }, payload = null) {
    commit('changeSurvey', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/repair/location/${payload.id}`);
    commit('changeSurvey', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });

      return result.data.object || {};
    }

    return false;
  },

  async searchMasterComponent({ commit }, payload = {}) {
    let result = await ApiGetRequest(`opr/repair/component`, payload);
    if (!result.error) {
      commit('changeSurvey', {
        items_component: result.data.object,
      });
    }
  },

  async getMasterComponent({ commit, state }, payload = null) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search_comp,
      page: data.page_comp,
      limit: data.limit_comp,
      sort: data.sortBy_comp,
      order: data.sortDesc_comp ? 'desc' : 'asc',
    };

    if (payload) {
      params = {
        ...params,
        ...payload,
      };
    }

    let result = await ApiGetRequest(`opr/repair/component`, params);
    if (!result.error) {
      commit('changeSurvey', {
        loading: false,
        data_comp: result.data.object || [],
        total_comp: result.data?.total || 0,
      });
    }
  },

  async downloadMasterComponent({ commit }) {
    commit('changeSurvey', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/repair/component/download`);
    commit('changeSurvey', {
      loading: false,
    });

    if (result.error) {
      return false;
    } else {
      // The actual download
      var blob = new Blob([result.data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'repair_component.csv';

      document.body.appendChild(link);

      link.click();
      document.body.removeChild(link);

      return true;
    }
  },

  async createMasterComponent({ commit, state, dispatch }) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest('opr/repair/component', data.form_comp);
    commit('changeSurvey', {
      loading: false,
    });
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });

      return result.data.object || {};
    }

    return false;
  },

  async updateMasterComponent({ commit, state, dispatch }, payload = null) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(
      `opr/repair/component/${payload.id}`,
      data.form_comp
    );

    commit('changeSurvey', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });

      return result.data.object || {};
    }

    return false;
  },

  async deleteMasterComponent({ commit, dispatch }, payload = null) {
    commit('changeSurvey', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/repair/component/${payload.id}`);
    commit('changeSurvey', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });

      return result.data.object || {};
    }

    return false;
  },

  async getMasterDamage({ commit, state }, payload = null) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search_dmg,
      page: data.page_dmg,
      limit: data.limit_dmg,
      sort: data.sortBy_dmg,
      order: data.sortDesc_dmg ? 'desc' : 'asc',
    };

    if (payload) {
      params = {
        ...params,
        ...payload,
      };
    }

    let result = await ApiGetRequest(`opr/repair/damage`, params);
    if (!result.error) {
      commit('changeSurvey', {
        loading: false,
        data_dmg: result.data.object || [],
        total_dmg: result.data?.total || 0,
      });
    }
  },

  async createMasterDamage({ commit, state, dispatch }) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest('opr/repair/damage', data.form_dmg);
    commit('changeSurvey', {
      loading: false,
    });
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });

      return result.data.object || {};
    }

    return false;
  },

  async updateMasterDamage({ commit, state, dispatch }, payload = null) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(
      `opr/repair/damage/${payload.id}`,
      data.form_dmg
    );

    commit('changeSurvey', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });

      return result.data.object || {};
    }

    return false;
  },

  async deleteMasterDamage({ commit, dispatch }, payload = null) {
    commit('changeSurvey', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/repair/damage/${payload.id}`);
    commit('changeSurvey', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });

      return result.data.object || {};
    }

    return false;
  },

  async searchMasterDamage({ commit }, payload = {}) {
    let result = await ApiGetRequest(`opr/repair/damage`, payload);
    if (!result.error) {
      commit('changeSurvey', {
        items_damage: result.data.object,
      });
    }
  },

  async getMasterAction({ commit, state }, payload = null) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search_ar,
      page: data.page_ar,
      limit: data.limit_ar,
      sort: data.sortBy_ar,
      order: data.sortDesc_ar ? 'desc' : 'asc',
    };

    if (payload) {
      params = {
        ...params,
        ...payload,
      };
    }

    let result = await ApiGetRequest(`opr/repair/action`, params);
    if (!result.error) {
      commit('changeSurvey', {
        loading: false,
        data_ar: result.data.object || [],
        total_ar: result.data?.total || 0,
      });
    }
  },

  async createMasterAction({ commit, state, dispatch }) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest('opr/repair/action', data.form_ar);
    commit('changeSurvey', {
      loading: false,
    });
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });

      return result.data.object || {};
    }

    return false;
  },

  async updateMasterAction({ commit, state, dispatch }, payload = null) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(
      `opr/repair/action/${payload.id}`,
      data.form_ar
    );

    commit('changeSurvey', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });

      return result.data.object || {};
    }

    return false;
  },

  async deleteMasterAction({ commit, dispatch }, payload = null) {
    commit('changeSurvey', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/repair/action/${payload.id}`);
    commit('changeSurvey', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });

      return result.data.object || {};
    }

    return false;
  },

  async searchContainerInterchange({ commit, state }, payload = null) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`opr/survey-in/container`, {
      q: payload?.value || '',
    });

    commit('changeSurvey', {
      loading: false,
    });

    if (!result.error) {
      let date_manufacture =
        result.data.object && result.data.object.date_manufacture
          ? result.data.object.date_manufacture
          : '';

      let month_manufacture = '';
      let year_manufacture = '';

      if (date_manufacture) {
        let data_mnf = date_manufacture.split('/');
        month_manufacture = data_mnf && data_mnf.length > 1 ? data_mnf[0] : '';
        year_manufacture = data_mnf && data_mnf.length > 1 ? data_mnf[1] : '';
      }

      commit('changeSurvey', {
        container_info: result.data.object || false,
        form: {
          ...data.form,
          ...result.data.object,
          out_harbor:
            result.data.object && result.data.object.out_harbor
              ? moment(result.data.object.out_harbor).format('DD/MM/YYYY')
              : '',
          month_manufacture,
          year_manufacture,
        },
      });
    }
  },

  async searchDataBooking({ commit, state }, payload = null) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`opr/survey-out/booking`, {
      q: payload?.value || '',
      payment: payload?.payment || '',
    });

    commit('changeSurvey', {
      loading: false,
    });

    if (!result.error) {
      let data_crani = result.data.object || {};

      commit('changeSurvey', {
        form: {
          ...data.form,
          ...data_crani,
          container_stock: data_crani.items || [],
        },
      });

      return true;
    }

    return false;
  },

  async container_stock({ commit, state }) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      principle:
        data.form && data.form.booking ? data.form.booking.id_principle : '',
    };

    let result = await ApiGetRequest(`opr/container/stock`, params);
    commit('changeSurvey', {
      loading: false,
    });

    if (!result.error) {
      commit('changeSurvey', {
        form: {
          ...data.form,
          items: !result.error ? result.data.object : [],
        },
        total: result.data.total || 0,
      });

      return true;
    }

    return false;
  },

  async get_container_crani({ commit, state }, payload = null) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`opr/survey-out/container/${payload.id}`);
    commit('changeSurvey', {
      loading: false,
    });

    if (!result.error) {
      commit('changeSurvey', {
        form: {
          ...data.form,
          ...result.data.object,
        },
      });

      return true;
    }

    return false;
  },

  async uploadImageSurvey({ commit, state }, payload) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`opr/photo`, payload);
    commit('changeSurvey', {
      loading: false,
    });

    if (!result.error) {
      let photo_survey = data.form.photo_survey || [];
      photo_survey.push(result.data.object);

      commit('changeSurvey', {
        form: {
          ...data.form,
          photo_survey,
        },
      });
    }
  },

  async uploadImageSurveyDamage({ commit, state }, payload) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`opr/photo`, payload);
    commit('changeSurvey', {
      loading: false,
    });

    if (!result.error) {
      let photo_damage = data.form_damage.photo_damage || [];
      photo_damage.push(result.data.object);

      commit('changeSurvey', {
        form_damage: {
          ...data.form_damage,
          photo_damage,
        },
      });
    }
  },

  async uploadImageSurveyDamageMore({ commit, state }, payload) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`opr/photo`, payload.form);
    commit('changeSurvey', {
      loading: false,
    });

    if (!result.error) {
      let data_form = data.form;
      let photo_damage = data_form.damages[payload.index].photo_damage || [];
      photo_damage.push(result.data.object);

      commit('changeSurvey', {
        form: data_form,
      });
    }
  },

  async changeFileDamage({ commit, state }, payload) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`opr/photo`, payload.form);
    commit('changeSurvey', {
      loading: false,
    });

    if (!result.error) {
      let data_form = data.form;
      let photo_damage = data_form.damages[payload.index].photo_damage || [];
      photo_damage[payload.changeId] = result.data.object;

      commit('changeSurvey', {
        form: data_form,
      });
    }
  },

  async uploadImageSurveySignature({ commit, state }, payload) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`opr/photo`, payload);
    commit('changeSurvey', {
      loading: false,
    });

    if (!result.error) {
      commit('changeSurvey', {
        form: {
          ...data.form,
          imageSignature: result.data.object,
        },
      });
    }
  },

  async getListSurveyIn({ commit, state }) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      page: data.page,
      limit: data.limit,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      condition: data.filter_condition ? data.filter_condition : '',
      status: data.filter_status ? data.filter_status : '',
    };

    let result = await ApiGetRequest(`opr/survey-in`, params);
    if (!result.error) {
      commit('changeSurvey', {
        loading: false,
        items: result.data.object || [],
        total: result.data?.total || 0,
      });
    }
  },

  async getListSurveyOut({ commit, state }) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      page: data.page,
      limit: data.limit,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      condition: data.filter_condition ? data.filter_condition : '',
    };

    let result = await ApiGetRequest(`opr/survey-out`, params);
    if (!result.error) {
      commit('changeSurvey', {
        loading: false,
        items: result.data.object || [],
        total: result.data?.total || 0,
      });
    }
  },

  async createSurveyData({ commit, state, dispatch }) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostRequest(`opr/survey-in`, data.form);
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });

      return true;
    }

    commit('changeSurvey', {
      loading: false,
    });

    return false;
  },

  async createSurveyDataOut({ commit, state, dispatch }) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostRequest(`opr/survey-out`, data.form);
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });

      return true;
    }

    commit('changeSurvey', {
      loading: false,
    });

    return false;
  },

  async updateSurveyData({ commit, state, dispatch }, payload = null) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPutRequest(
      `opr/survey-in/${payload.id}`,
      data.form
    );
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });

      return true;
    }

    commit('changeSurvey', {
      loading: false,
    });

    return false;
  },

  async updateSurveyDataOut({ commit, state, dispatch }, payload = null) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPutRequest(
      `opr/survey-out/${payload.id}`,
      data.form
    );
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });

      return true;
    }

    commit('changeSurvey', {
      loading: false,
    });

    return false;
  },

  async deleteSurveyData({ commit, dispatch }, payload = null) {
    commit('changeSurvey', {
      loading: true,
    });

    const result = await ApiDeleteRequest(`opr/survey-in/${payload.id}`);
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });

      return true;
    }

    commit('changeSurvey', {
      loading: false,
    });

    return false;
  },

  async deleteSurveyOut({ commit, dispatch }, payload = null) {
    commit('changeSurvey', {
      loading: true,
    });

    const result = await ApiDeleteRequest(`opr/survey-out/${payload.id}`);
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });

      return true;
    }

    commit('changeSurvey', {
      loading: false,
    });

    return false;
  },

  async getDownloadFiles({ commit }, payload = null) {
    commit('changeSurvey', {
      loading: true,
    });

    let result = await ApiPostRequest('opr/download', {
      ...payload,
    });

    commit('changeSurvey', {
      loading: false,
    });
    if (result) {
      return result.data.object;
    }
  },

  async getDetailSurvey({ commit, state }, payload = null) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiGetRequest(`opr/survey-in/${payload.id}`);
    if (!result.error) {
      let date_manufacture =
        result.data.object && result.data.object.date_manufacture
          ? result.data.object.date_manufacture
          : '';

      let month_manufacture = '';
      let year_manufacture = '';

      if (date_manufacture) {
        let data_mnf = date_manufacture.split('/');
        month_manufacture = data_mnf && data_mnf.length > 1 ? data_mnf[0] : '';
        year_manufacture = data_mnf && data_mnf.length > 1 ? data_mnf[1] : '';
      }

      commit('changeSurvey', {
        form: {
          ...data.form,
          ...result.data.object,
          out_harbor:
            result.data.object && result.data.object.out_harbor
              ? moment(result.data.object.out_harbor).format('DD/MM/YYYY')
              : '',
          ventilasi:
            result.data.object && result.data.object.ventilasi
              ? result.data.object.ventilasi
              : '',
          floor_type:
            result.data.object && result.data.object.floor_type
              ? result.data.object.floor_type
              : '',
          month_manufacture,
          year_manufacture,
        },
        loading: false,
      });

      return true;
    }

    commit('changeSurvey', {
      loading: false,
    });

    return false;
  },

  async getDetailSurveyOut({ commit, state }, payload = null) {
    commit('changeSurvey', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiGetRequest(`opr/survey-out/${payload.id}`);
    if (!result.error) {
      commit('changeSurvey', {
        form: {
          ...data.form,
          ...result.data.object,
        },
        loading: false,
      });

      return true;
    }

    commit('changeSurvey', {
      loading: false,
    });

    return false;
  },
};
